<template>
  <b-modal
      hide-footer
      v-model="localVisible"
      @hide="closeModal"
      :title="$t('transaction-reason-modal-title')"
  >
    <b-form-group :label="$t('english-reason')" label-for="english_reason">
      <b-form-textarea
          id="english_reason"
          required
          v-model="reasons.en"
      ></b-form-textarea>
    </b-form-group>

    <b-form-group :label="$t('german-reason')" label-for="german_reason">
      <b-form-textarea
          id="german_reason"
          required
          v-model="reasons.de"
      ></b-form-textarea>
    </b-form-group>

    <b-button
        class="btn mt-1"
        variant="primary"
        @click="submitChanges"
    >
      {{ $t('change') }}
    </b-button>
  </b-modal>
</template>

<script>
export default {
  props: {
    isVisible: Boolean,
    item: Object,
  },
  data(){
    return {
      reasons:{
        en:null,
        de:null
      }
    };
  },
  created() {
    const parsedItem = JSON.parse(this.item.admin_transaction_reason);
    this.reasons.en = parsedItem.en;
    this.reasons.de = parsedItem.de;
  },
  computed: {
    localVisible: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit('update:isVisible', value);
      }
    }
  },
  methods: {
    closeModal() {
      this.localVisible = false;
    },
    submitChanges(){
      let payload = {};
      if(this.reasons.en !== null){
        payload.en_description = this.reasons.en
      }
      if(this.reasons.de !== null){
        payload.de_description = this.reasons.de
      }
      this.$http.patch(`/transactions/admin/${this.item.id}/edit-details`, payload).then(()=>{
        location.reload();
      });
    }
  }
}
</script>

<style scoped>
</style>